import { type SurfaceAnalyticsArtifact } from '@atlassian/surface-analytics-specs';

type CCPProductUUID = string;

/**
 * Product names, convention of CCP product names
 */
export type ProductNames =
	| 'jira_software_cloud'
	| 'jira_work_management_cloud'
	| 'jira_service_management_cloud'
	| 'jira_product_discovery'
	| 'confluence_cloud'
	| 'opsgenie'
	| 'teamwork_collection'
	| 'loom';

export const PROD_FIRST_PARTY_CCP_PRODUCT_IDS: Record<ProductNames, CCPProductUUID> = {
	jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
	jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
	jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
	jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
	confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
	opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
	teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
	loom: '7683a73e-423d-41a1-b43f-d497656f8b5d',
};

export const STAGING_FIRST_PARTY_CCP_PRODUCT_IDS: Record<ProductNames, CCPProductUUID> = {
	jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
	jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
	jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
	jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
	confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
	opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
	teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
	loom: '7683a73e-423d-41a1-b43f-d497656f8b5d',
};

/**
 * The first party CCP product IDs:
 *
 * Only use this static CCP Product IDs when we intend to expand to specific 1P products.
 * Should use the CCP product IDs from backend service when the recommended products come from backend service,
 * e.g. recommendation engine.
 */
export const FIRST_PARTY_CCP_PRODUCT_IDS: {
	prod: Record<ProductNames, string>;
	staging: Record<ProductNames, string>;
} = {
	prod: PROD_FIRST_PARTY_CCP_PRODUCT_IDS,
	staging: STAGING_FIRST_PARTY_CCP_PRODUCT_IDS,
};

/**
 * The static mapping between crossflow reference ids and CCP product IDs.
 */
export const SURFACE_ANALYTICS_PRODUCT_MAP: SurfaceAnalyticsArtifact = {
	products: {
		'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
		'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
		'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
		'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
		opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
		statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
		townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
		compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
		'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
		beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
		'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
		mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
		'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
		loom: '7683a73e-423d-41a1-b43f-d497656f8b5d',
	},
};
